export default {
  data() {
    return {
      editingFields: {},
      originalValues: {},
    }
  },

  methods: {
    generateFieldKey(path) {
      return Array.isArray(path) ? path.join('_') : path
    },

    // Get nested value from object using path array
    getNestedValue(obj, path) {
      return path?.reduce((current, key) => current && current[key], obj)
    },

    // Set nested value in object using path array
    setNestedValue(obj, path, value) {
      const pathCopy = [...path]
      const lastKey = pathCopy.pop()
      const target = pathCopy.reduce((current, key) => {
        if (!current[key]) {
          this.$set(current, key, {})
        }
        return current[key]
      }, obj)
      target[lastKey] = value
    },

    // Check if any field is being edited
    isFieldEditing(rootIndex, fieldPath) {
      const key = this.generateFieldKey([rootIndex, ...fieldPath])
      return !!this.editingFields[key]
    },

    // Toggle edit mode for any field
    toggleFieldEdit(rootIndex, fieldPath, currentValue) {
      if (this.isFieldEditing(rootIndex, fieldPath)) {
        // Save and exit edit mode
        this.saveFieldEdit(rootIndex, fieldPath)
      } else {
        // Enter edit mode
        this.startFieldEdit(rootIndex, fieldPath, currentValue)
      }
    },

    // Start editing any field
    startFieldEdit(rootIndex, fieldPath, currentValue) {
      const key = this.generateFieldKey([rootIndex, ...fieldPath])

      this.originalValues[key] = currentValue

      this.$set(this.editingFields, key, true)
    },

    // Save field changes
    saveFieldEdit(rootIndex, fieldPath) {
      const key = this.generateFieldKey([rootIndex, ...fieldPath])
      this.$set(this.editingFields, key, false)

      const fieldName = fieldPath[fieldPath.length - 1]
      const dataSource = this.campaigns || []
      const currentValue = this.getNestedValue(dataSource, [rootIndex, ...fieldPath])

      this.$emit('field-saved', {
        rootIndex,
        fieldPath,
        fieldName,
        currentValue,
      })
    },

    cancelFieldEdit(rootIndex, fieldPath) {
      const key = this.generateFieldKey([rootIndex, ...fieldPath])

      if (this.originalValues[key] !== undefined) {
        const dataSource = this.campaigns || []
        this.setNestedValue(dataSource, [rootIndex, ...fieldPath], this.originalValues[key])
      }

      this.$set(this.editingFields, key, false)
    },

    updateFieldValue(rootIndex, fieldPath, value) {
      const dataSource = this.campaigns || []
      this.setNestedValue(dataSource, [rootIndex, ...fieldPath], value)
    },
  },
}
